export default "__VITE_ASSET__DnlIPiTy__"